import React from "react";
// import Routes from "./Router";
import Authenticator from "./Authenticator";
import { createBrowserHistory } from 'history';



const history = createBrowserHistory();

function App() {
    return (
        <Authenticator history={history}>
            {/* <Routes /> */}
        </Authenticator>
    );
}

export default App;